import { render, staticRenderFns } from "./recommendationListDialog.vue?vue&type=template&id=f43b418c&scoped=true"
import script from "./recommendationListDialog.vue?vue&type=script&lang=js"
export * from "./recommendationListDialog.vue?vue&type=script&lang=js"
import style0 from "./recommendationListDialog.vue?vue&type=style&index=0&id=f43b418c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f43b418c",
  null
  
)

export default component.exports